import { Tabs as BootstrapTabs, TabsProps } from 'react-bootstrap'

import styled from 'styled-components'

import { Colours } from '@lib/theme'

const InventoryTabs = styled(BootstrapTabs)`
  font-size: 0.8rem;
  > li {
    .nav-link {
      color: #7a7a7a;
      background-color: transparent;
      &.active {
        background-color: rgba(255, 255, 255, 0.7);
        /* Using text-shadow on active tab to prevent the text growing/shrinking with font-weight */
        text-shadow: 0px 0px 0px black;
        border-bottom: 2px solid ${Colours.Brand.BlueMid};
      }
    }
  }
`

export function Tabs({ children, ...props }: Readonly<TabsProps>) {
  return <InventoryTabs {...props}>{children}</InventoryTabs>
}
